module.exports = __webpack_public_path__ + "static/img/logo.c5e4086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo.png
// module id = Vpqn
// module chunks = 38